import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, RefreshCwIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="w-full bg-navy py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-199">
      {/* Geometric accent */}
      <div className="absolute top-0 right-0 w-1/3 h-full opacity-5" data-id="element-200">
        <svg viewBox="0 0 200 200" className="w-full h-full" data-id="element-201">
          <path d="M0 0 L200 0 L200 200 Z" fill="currentColor" className="text-teal" data-id="element-202" />
          <path d="M50 50 L150 50 L150 150 Z" fill="none" stroke="currentColor" strokeWidth="2" className="text-teal" data-id="element-203" />
        </svg>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-205">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-206">
            La verdad:{' '}
            <span className="text-teal" data-id="element-207">no es un problema de disciplina</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-208">
            Si tu plan depende de "tener ganas", estás apostando a la parte más
            inestable de ti.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="bg-navy-light rounded-2xl p-8 sm:p-12 mb-16 border-2 border-teal/30" data-id="element-209">
          <p className="text-2xl text-white font-semibold mb-6" data-id="element-210">
            Tu cerebro no está "siendo malo".
          </p>
          <p className="text-xl text-gray-300 leading-relaxed" data-id="element-211">
            Está buscando alivio rápido. El feed infinito es una máquina
            perfecta para eso.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} className="mb-16" data-id="element-212">
          <h3 className="text-3xl font-bold text-white mb-8 text-center" data-id="element-213">
            El método: <span className="text-teal" data-id="element-214">Fricción + Reemplazo</span>
          </h3>
          <p className="text-xl text-gray-300 text-center mb-12 max-w-3xl mx-auto" data-id="element-215">
            Este sistema funciona porque no pelea contra tu cerebro. Lo
            rediseña.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-216">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.7,
            duration: 0.6
          }} className="bg-white rounded-xl p-8" data-id="element-217">
              <div className="bg-teal/10 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-218">
                <ShieldIcon className="w-8 h-8 text-teal" aria-hidden="true" data-id="element-219" />
              </div>
              <h4 className="text-2xl font-bold text-navy mb-4" data-id="element-220">1) FRICCIÓN</h4>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-221">
                Hacemos que el scroll sea incómodo: más pasos, más distancia,
                menos estímulo.
              </p>
              <p className="text-gray-700 leading-relaxed font-semibold" data-id="element-222">
                No para castigarte. Para romper el automático.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.9,
            duration: 0.6
          }} className="bg-white rounded-xl p-8" data-id="element-223">
              <div className="bg-teal/10 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-224">
                <RefreshCwIcon className="w-8 h-8 text-teal" aria-hidden="true" data-id="element-225" />
              </div>
              <h4 className="text-2xl font-bold text-navy mb-4" data-id="element-226">
                2) REEMPLAZO (60–120 segundos)
              </h4>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-227">
                Cuando llega el impulso, no te quedas "aguantando".
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-228">
                Le das al cuerpo una mini-salida: respiración, arranque feo,
                micro-objetivo, reset físico… lo suficiente para que vuelvas al
                material{' '}
                <span className="font-semibold text-teal" data-id="element-229">
                  sin caer en el feed.
                </span>
              </p>
            </motion.div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 1.1,
        duration: 0.6
      }} className="text-center bg-teal/10 rounded-xl p-8 border-2 border-teal" data-id="element-230">
          <p className="text-2xl font-bold text-white" data-id="element-231">
            Resultado: empiezas a ganar el momento que siempre te ganaba.
          </p>
        </motion.div>
      </div>
    </section>;
}